import _ from 'lodash'
import wAxios from '@/plugins/w/axios/models/axios'
import { buildQueryFilters, createApiHook } from '@/plugins/app/api'
import { useAuthStore } from '@/plugins/w/auth/store/auth.store'

export interface SummaryRequestsFilters {
	search?: string
	date?: string
	last_result?: {
		start?: string
		end?: string
	}
}

export const QUERY_KEY = 'summary-requests'

export const DEFAULT_FILTERS: SummaryRequestsFilters = {
	search: '',
	date: '',
	last_result: {
		start: '',
		end: ''
	}
}

export const fetchFn = async (pagination: Pagination, filters: SummaryRequestsFilters = {}) => {
	const query = fetchQuery(pagination, filters)
	const params = buildQueryFilters(query)
	
	return wAxios
		.get_auth(`/v1/requests/summary?${params}`)
		.catch(error => Promise.reject(error.response || error))
}

export const fetchQuery = (pagination: Pagination, filters: SummaryRequestsFilters) => {
	const filtersWithDefaults = _.defaults(filters, DEFAULT_FILTERS)

	const query = {
		per_page: Number(pagination.per_page),
		page: Number(pagination.current_page),
		search: filtersWithDefaults.search?.trim() || '',
		date_from: '',
		date_to: '',
		accesses: [useAuthStore().getCurrentAccess?.id]
	}

	if (filtersWithDefaults.date && filtersWithDefaults.date !== '') {
		query.date_from = filtersWithDefaults.date
		query.date_to = filtersWithDefaults.date
	} else if (
		filtersWithDefaults.last_result &&
		filtersWithDefaults.last_result.start !== '' &&
		filtersWithDefaults.last_result.end !== ''
	) {
		query.date_from = filtersWithDefaults.last_result.start
		query.date_to = filtersWithDefaults.last_result.end
	} else {
		delete query.date_from
		delete query.date_to
	}

	return query
}

export const useGetSummaryRequests = createApiHook(fetchFn, QUERY_KEY, fetchQuery)
